/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Organize_EmptyInputs */

const en_us2_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workouts yet. Add the first one.`)
};

const pt_br2_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino ainda. Adicione o primeiro.`)
};

const es_419_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay entrenamientos. Agrega el primero.`)
};

const pt_pt2_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda nenhum treino. Adiciona o primeiro.`)
};

const fr_fr2_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance pour l'instant. Ajoute la première.`)
};

const de_de2_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Trainings. Füg das erste hinzu.`)
};

const it_it2_plan_build_organize_empty = /** @type {(inputs: Plan_Build_Organize_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun allenamento. Aggiungi il primo.`)
};

/**
* | output |
* | --- |
* | "No workouts yet. Add the first one." |
*
* @param {Plan_Build_Organize_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_empty = /** @type {((inputs?: Plan_Build_Organize_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_empty(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_empty(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_empty(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_empty(inputs)
	return en_us2_plan_build_organize_empty(inputs)
});
export { plan_build_organize_empty as "plan-build.organize_empty" }